import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ErrorPayload } from "../../../../interfaces/auth/IErrorPayload";
import { UserPassPayload } from "../../../../interfaces/auth/IUser";
import { useLoginMutation } from "../../../../store/auth/authApi";
import Input from "../../../../shared/input";
import Loading from "../../../../shared/Loading";
import { decodeJWT } from "../../../../utils/decodeJWT";
import { SALON_USERNAME } from "../../../../utils/constants/salonEmail";
import Button from "../../../../shared/button";

const LoginForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserPassPayload>();
  const [loginMutation, { isLoading, error }] = useLoginMutation();
  const navigate = useNavigate();
  let errorMsg: any;

  const onSubmit = async (payload: UserPassPayload) => {
    try {
      const { data } = await loginMutation(payload).unwrap();
      const roles = data.servicePayload.accessToken.payload["cognito:groups"];
      localStorage.setItem("accessToken", data.token);
      localStorage.setItem("refreshToken", data.refreshToken);
      localStorage.setItem("roles", roles?.[0] || "");
      const decodedToken = decodeJWT(data.token);
      console.log({ decodedToken });
      navigate(
        roles?.[0] === "admins"
          ? "/users"
          : roles?.[0] === "suppliers"
          ? "/invoices"
          : decodedToken["cognito:username"] === SALON_USERNAME
          ? "/saloon-home/"
          : "/insights"
      );
    } catch (err: any) {
      errorMsg = err?.data?.message;
    }
  };

  const err = { ...(error as ErrorPayload) };
  errorMsg =
    err.status === 401
      ? "Username or password are incorrect"
      : "Something went wrong";
  return (
    <>
      <form
        className="mt-8 mb-5 w-full md:w-6/12 mx-auto"
        onSubmit={handleSubmit(onSubmit)}
      >
        <h2 className="text-lg md:text-2xl font-semibold mb-2">Log in</h2>
        {!!err.data && (
          <div
            className="p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
            role="alert"
          >
            <span className="font-medium">
              {" "}
              {err.data.message || errorMsg}{" "}
            </span>
          </div>
        )}
        <Input
          placeholder=""
          label="Your email"
          register={register("username", {
            required: {
              message: "Username is required",
              value: true,
            },
            validate: (value: string) =>
              !!value.trim() || "Username is required",
          })}
          error={errors.username?.message}
        />
        <Input
          placeholder="********"
          type="password"
          label="Your password"
          register={register("password", {
            required: {
              message: "Password is required",
              value: true,
            },
          })}
          error={errors.password?.message}
        />
        <Button
          className="w-full bg-saloon-btn hover:bg-opacity-80 p-3 text-saloon-primary rounded-3xl font-semibold text-base mt-8"
          type="submit"
          label={
            <>
              {isLoading && <Loading />}
              Login
            </>
          }
        />
      </form>
    </>
  );
};

export default LoginForm;
